module.exports = __webpack_public_path__ + "img/header-memoireRingsSignature@2x.f665182.webp";